import axios from 'axios';
import authHeader from './auth-header';
import { API_URL as BASE_API_URL } from './config';

const API_URL = BASE_API_URL;

class OrderService {

  getOrder(page, search = null) {
    let url = API_URL + "/admin/orders?page=" + page;
    if (search) {
      url += "&search=" + encodeURIComponent(search);
    }
    return axios.get(url, { headers: authHeader() });
  }

  createOrder(orderData) {
    return axios.post(API_URL + "/admin/orders", orderData, { headers: authHeader() });
  }


  // id.dhbtools.com
  async getAllOrder(page, search = null) {
    let url = API_URL + "/admin/orders-id?page=" + page;
    if (search) {
      url += "&search=" + encodeURIComponent(search);
    }

    return await axios.get(url, { headers: authHeader() }).then(response => {
      return response.data;
    });
  }

  async getOrderById(id) {
    return await axios.get(API_URL + "/admin/orders-id/" + id, { headers: authHeader() }).then(response => {
      return response.data;
    });
  }

  async updateOrder(id, paymentStatus) {
    return await axios.put(API_URL + "/admin/orders-id/" + id, { paymentStatus: paymentStatus }, { headers: authHeader() }).then(response => {
      return response.data;
    });
  }

}

export default new OrderService();
